import './FormControl.css';
export default {
    "primaryLabel": "FormControl_primaryLabel__zu86j",
    "primaryLabelOpen": "FormControl_primaryLabelOpen__zu86j",
    "root": "FormControl_root__zu86j",
    "primaryLabelRequired": "FormControl_primaryLabelRequired__zu86j",
    "fieldContainer": "FormControl_fieldContainer__zu86j",
    "fieldContainerFullWidth": "FormControl_fieldContainerFullWidth__zu86j",
    "main": "FormControl_main__zu86j",
    "aside": "FormControl_aside__zu86j",
    "helperText": "FormControl_helperText__zu86j",
    "prefix": "FormControl_prefix__zu86j",
    "suffix": "FormControl_suffix__zu86j",
    "validationAdornment": "FormControl_validationAdornment__zu86j",
    "error": "FormControl_error__zu86j",
    "disabled": "FormControl_disabled__zu86j"
};
